import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Button, DialogContentText } from '@material-ui/core/';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import InfoIcon from '@material-ui/icons/Info';
import { get, omit, set } from 'lodash-es';
import { isNil } from 'lodash';
import ChipInput from 'material-ui-chip-input';
import moment from 'moment-timezone';
import React, { JSX, ReactElement } from 'react';
import { default as NumberFormat } from 'react-number-format';
import { v4 as uuid } from 'uuid';
// @ts-ignore
import * as yup from 'yup';

import { getSmallSites } from '~/src/dash/api/channels/channels_methods';
import { ISmallSite } from '~/src/dash/api/channels/channels_models';
import {
  EAllowStatus,
  IAudienceSegment,
  ISite,
  makeTargetingChangeDescription,
  makeTargetingChangeInfoHover,
  ResourceActiveDisabled,
  ResourceActiveEnabled,
  reverseEAllowStatus,
  SegmentTargetingAND,
  SegmentTargetingOR,
} from '~/src/dash/api/console-api';
import { getContextualSegmentsByPublisherID } from '~/src/dash/api/contextual-segments';
import { dealActiveStatusChangeHandler } from '~/src/dash/api/deal_samsung';
import {
  AuctionType,
  DEAL_SSP_BOTH_LIST,
  DEAL_SSP_WITH_API_LIST,
  DEAL_SSP_WITHOUT_API_LIST,
  DealBidderType,
  DealType,
  getDealBidderType,
  getIndexExchangeSeatIDs,
  GetPublicaDealBidRequestFlag,
  IDeal,
  IIndexExchangeToPublicaApiDeal,
  IPublicaDealHasMadeBidRequest,
  ISamsungDealParams,
  ISeatGroup,
  IUnrulyDealBuyer,
  IUnrulyDealParams,
  OpenMarket,
  SamsungDealStatus,
} from '~/src/dash/api/deals';
import {
  convertECurrencyTypeToString,
  convertStringToECurrencyType,
  CurrencyDisplayedItem,
  CurrencyType,
  CurrencyTypeUSD,
  ECurrencyType,
} from '~/src/dash/api/exchange-rates';
import { EBool } from '~/src/dash/api/types/bool';
import ConfirmationDialogButton from '~/src/dash/components/confirmation-dialog-button';
import { CurrencyConverter } from '~/src/dash/components/CurrencyConverter';
import { UserMultiSelect } from '~/src/dash/components/dropdowns/user-multi-select';
import {
  DateTimeRangeComponent,
  IDateRangeChangeEvent,
} from '~/src/dash/components/datepicker/date-time-range-component';
import { AudienceSegmentTargetingMultiSelect } from '~/src/dash/components/form/audience/audience-segment-targeting-multi-select';
import { ChannelGroupTargetingMultiSelect } from '~/src/dash/components/form/channel-group/channel-group-targeting-multi-select';
import { DealBidderTypeSelect } from '~/src/dash/components/form/deal/deal-bidder-type-select';
import { IndexExchangeDSPTargetingSelect } from '~/src/dash/components/form/deal/indexexchange-dsp-targeting-select';
import { UnrulyDSPTargetingSelect } from '~/src/dash/components/form/deal/unruly-dsp-targeting-select';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { LiveData } from '~/src/dash/components/live-data/live-data';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { ModelPrimaryContainer } from '~/src/dash/components/model-grid-container';
import ModelMissingPermission from '~/src/dash/components/model-missing-permission';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { SettingsAppBar } from '~/src/dash/components/settings-app-bar';
import { ITab, SettingsTabs } from '~/src/dash/components/settings-tabs';
import {
  Col,
  Cols,
  ct,
  Div,
  Panel,
  Panels,
  Row,
  Rows,
  spacing,
  Text,
  TooltipWithTranslation,
} from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import {
  extractRouteParams,
  getRoutePath,
  navigate,
  RouteDealList,
  RouteDealTPAccountList,
} from '~/src/dash/router/routes';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorate } from '~/src/dash/utils/decorator';
import { adminDebugColor, smallRadius } from '~/src/dash/utils/material-dashboard-react';
import { filterSitesByActive } from '~/src/dash/utils/models';
import {
  IPermissionCheck,
  IS_AUTHORIZED,
  notAllowedEmptyIPermissionCheck,
} from '~/src/dash/utils/permission_service';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { hasErrors, IErrors } from '~/src/dash/utils/validator';
import { HeadingCategory } from '~/src/dash/views/component-view';
import { DealPrioritySelect } from '~/src/dash/views/deal/forms/DealPrioritySelect';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  audienceSegments: IAudienceSegment[];
  deal: IDeal;
  siteIDsList: IMenuList;
  seatIDsList: IMenuList;
  inventoryGroupIDsList: IMenuList;
  tokenStatus: boolean;
  onChange: (deal: IDeal) => void;
  onSubmit: (deal: IDeal) => void;
  onClose: () => void;
  onDelete: (deal: IDeal) => void;
  cloneUrl: string;
}

interface IState extends IBaseState {
  /**
   * Global View state
   */
  loading: boolean;
  isUpdating: boolean;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;

  // Snackbar state
  snackbarMessage: string;
  snackbarError: boolean;
  // Modal state
  deleteModelActive: boolean;

  // Form data
  channelList: IMenuList;
  Channels: ISmallSite[];
  demandPartner: string;
  demandPartners: IMenuList;
  contextualSegmentList: IMenuList;
  siteIDsList: IMenuList;
  seatIDsList: IMenuList;
  inventoryGroupIDsList: IMenuList;
  shouldRefreshDealPrioritySelect: boolean;

  // Did the deal made bid request(s)?
  didDealMakeBidRequest: boolean | undefined;

  // Do we want to open the Samsung warning popup?
  isSamsungPopupOpen: boolean;

  tokenStatus: boolean;

  errors: { [key: string]: any };
}

function isExistingDeal(deal: IDeal): boolean {
  return !!deal.ID;
}

const DealSettingsFormSchema = {
  // Validation schema for Unruly (Rhythm One).
  rhythmone: yup.object().shape({
    ID: yup
      .number()
      .test(
        'StartDate',
        'StartDate Start time must be in the future.',
        (value: any, context: any) => {
          // INFO: This is validating 'StartDate'. We're implementing the test here because yup's test cannot access the
          // parent's field in an object, so StartDate cannot access ID to check if we're updating or creating.
          // If we're updating a deal (not creating), ignore this test.
          if (value !== 0) {
            return true; // Always passing
          }
          // We're creating a deal, check if start date is in the future.
          return context.parent.SspParams.startDate.getTime() / 1000 > moment().unix();
        },
      ),
    BidderType: yup.string().required(),
    Name: yup.string().required(),
    SspParams: yup.object().shape({
      PackageID: yup.number().required(),
      startDate: yup
        .date()
        .max(yup.ref('endDate'), 'StartDate Start time must be before end time.'),
      endDate: yup.date().max('2037-01-01', 'EndDate End time exceeds future limit.'),
      Buyers: yup
        .array()
        .of(
          yup.object().shape({
            DspID: yup.number().required(),
          }),
        )
        .min(1, 'Buyers The deal should have at least ${min} buyer.'),
      // TODO: Use yup's when clause to enforce a minDate on the startDate if the deal is new
    }),
  }),

  // Validation schema for Samsung
  samsungssp: yup.object().shape({
    BidderType: yup.string().required(),
    Name: yup.string().required(),
    ImpressionGoal: yup.number().required().min(1),
    StartDate: yup.string().required(),
    EndDate: yup.string().required(),
    SspParams: yup.object().shape({
      ecpm: yup.number().required().min(0.001).max(9999999.999),
      partnerName: yup.string().required(),
      status: yup.string().required(),
      totalAdvBudget: yup.number().required().min(0.01),
    }),
  }),

  // Validation schema for all the SSPs without an API.
  sspWithoutAPI: yup.object().shape({
    BidderType: yup.string().required('BidderType Please select a bidder type.'),
    Name: yup.string().required('Name The deal name is invalid.'),
    DealKey: yup.string().required('DealKey The deal key is invalid.'),
  }),

  // Validation schema for PG deals.
  programmaticGuaranteed: yup.object().shape({
    BidderType: yup.string().required('BidderType Please select a bidder type.'),
    Name: yup.string().required('Name The deal name is invalid.'),
    DealKey: yup.string().required('DealKey The deal key is invalid.'),
    StartDate: yup.string().required('StartDate Please select a start date.'),
    EndDate: yup.string().required('EndDate Please select an end date.'),
    ImpressionGoal: yup
      .string()
      .matches(/[^0.,\n]/, 'ImpressionGoal Please enter an impression goal.'), // https://regex101.com/r/qvhgBo/1
  }),

  // Validation schema for Index Exchange (IX).
  indexExchange: yup.object().shape({
    ID: yup
      .number()
      .test(
        'StartDate',
        'StartDate Start time must be in the future.',
        (value: any, context: any) => {
          // INFO: This is validating 'StartDate'. We're implementing the test here because yup's test cannot access the
          // parent's field in an object, so StartDate cannot access ID to check if we're updating or creating.
          // If we're updating a deal (not creating), ignore this test.
          if (value !== 0) {
            return true; // Always passing
          }
          // We're creating a deal, check if start date is in the future.
          return context.parent.SspParams.startDate.getTime() / 1000 > moment().unix();
        },
      ),
    BidderType: yup.string().required(),
    SspParams: yup.object().shape({
      dealID: yup.string().required(),
      dspID: yup.number().required(),
      name: yup.string().required(),
      startDate: yup
        .date()
        .max(yup.ref('endDate'), 'StartDate Start time must be before end time.'),
      endDate: yup.date().max('2037-01-01', 'EndDate End time exceeds future limit.'),
      auctionType: yup.string().required(),
      rate: yup.number().required(),
      // TODO: Use yup's when clause to enforce a minDate on the startDate if the deal is new
    }),
  }),
};

export const DealSettingsForm = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      mainGridItem: {
        marginLeft: 22,
        marginRight: 22,
        marginTop: 25,
      },
      formControlLabel: {
        fontSize: 12,
        fontWeight: 400,
        color: '$434343',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);
      this.state = {
        /**
         * Global View state
         */
        loading: true,
        isUpdating: false,
        readAuthorization: notAllowedEmptyIPermissionCheck,
        writeAuthorization: notAllowedEmptyIPermissionCheck,

        // Snackbar state
        snackbarMessage: '',
        snackbarError: false,
        // Modal state
        deleteModelActive: false,

        /**
         * Form state
         */
        // Form data
        Sites: [] as ISite[],
        channelList: {} as IMenuList,
        Channels: [] as ISmallSite[],
        demandPartner: '',
        demandPartners: {} as IMenuList,

        didDealMakeBidRequest: undefined, // not initialized yet

        isSamsungPopupOpen: false, // don't open the samsung warning popup by default

        errors: {},
        contextualSegmentList: {} as IMenuList,
        ContextualSegmentIDS: this.props.deal.ContextualSegmentIDS || [],
        siteIDsList: this.props.siteIDsList || [],
        seatIDsList: this.props.seatIDsList || [],
        inventoryGroupIDsList: this.props.inventoryGroupIDsList || [],
        tokenStatus: this.props.tokenStatus,

        Priority: -1,
      };
    }

    validateForm = (): boolean => {
      const errors = {}; /* validate(this.state)*/
      if (hasErrors(errors)) {
        this.setState({
          errors,
        });
        return false;
      }
      this.setState({
        errors: {} as IErrors,
      });
      return true;
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
        errors: {} as IErrors,
      });
    };

    gotoDealListView = () => {
      navigate(
        RouteDealList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    };

    deleteDealSettings = () => {
      this.setState({
        deleteModelActive: true,
      });
    };

    onHideDeleteDialog = () => {
      this.setState({
        deleteModelActive: false,
      });
    };

    onDeleteDeleteDialog = () => {
      this.onHideDeleteDialog();
      this.gotoDealListView();
    };

    componentDidMount(): void {
      // get variable from props
      const { deal } = this.props;

      // variable used to store all the update in the state, so we apply them all at once
      const stateUpdates = {} as IState;

      // set the rights
      stateUpdates.readAuthorization = IS_AUTHORIZED(['read_deal'], this.props.user.user);
      stateUpdates.writeAuthorization = IS_AUTHORIZED(['write_deal'], this.props.user.user);

      // set the deal bid request flag; used to enable/disable the deal type editing
      if (this.props.deal.ID <= 0) {
        stateUpdates.didDealMakeBidRequest = false; // we're creating a deal, it cannot have made bid request(s)
      } else {
        // we're editing a deal, check with the API if it made some bid request(s)
        GetPublicaDealBidRequestFlag(this.props.session.publisher.ID, deal.ID).then(
          (resp: IPublicaDealHasMadeBidRequest) => {
            this.setState({
              didDealMakeBidRequest: resp.DealHasMadeBidRequest,
            });
          },
        );
      }

      // if the opened deal is a Samsung deal and it's status is stopped, display a message to let the user know
      // that they cannot edit this deal
      if (
        deal.BidderType === 'samsungssp' &&
        (deal.SspParams as ISamsungDealParams).isDealStopped
      ) {
        stateUpdates.snackbarError = true;
        stateUpdates.snackbarMessage = 'This Samsung deal is stopped, it cannot be edited.';
      }

      // apply all the pending updates in the state
      this.setState(stateUpdates);

      this.genChannelList();
      this.genContextualSegmentList();
      if ((deal.SspParams as IIndexExchangeToPublicaApiDeal).dspID) {
        this.loadIndexExchangeSeatIDs((deal.SspParams as IIndexExchangeToPublicaApiDeal).dspID);
      }
    }

    componentDidUpdate(prevProps: Readonly<IProps>): void {
      // Rights
      if (!prevProps || prevProps.user.user !== this.props.user.user) {
        this.setState({
          readAuthorization: IS_AUTHORIZED(['read_deal'], this.props.user.user),
          writeAuthorization: IS_AUTHORIZED(['write_deal'], this.props.user.user),
        });
      }

      if (prevProps.deal.ID !== this.props.deal.ID) {
        this.genChannelList();
      }
    }

    genChannelList = async () => {
      const dealChannels = this.props.deal.Channels || [];
      const channelList: IMenuList = {};
      const dealChannelIDs = dealChannels.map((dealChannel) => dealChannel.ID);

      // If new deal, only show active channels
      const [small_sites, err] = await getSmallSites(this.props.session.publisher.ID);
      if (err) {
        console.error(err);
        return;
      }

      let renderedSites = small_sites || [];
      if (!isExistingDeal(this.props.deal)) {
        renderedSites = filterSitesByActive(renderedSites);
      }
      renderedSites.forEach((site: ISmallSite) => {
        const siteName = checkUserInfoMasked(this.props.user.user)
          ? 'demo_site_' + site.ID
          : site.Name;
        channelList[site.ID] = {
          title: siteName,
          selected: dealChannelIDs.includes(site.ID),
          ID: site.ID.toString(),
        };
      });

      this.setState({
        channelList,
        Channels: renderedSites,
      });
    };

    loadIndexExchangeSeatIDs = (dspID: number) => {
      getIndexExchangeSeatIDs(this.props.session.publisher.ID, dspID)
        .then((res: [ISeatGroup | undefined, string | undefined]) => {
          if (res[0] !== undefined) {
            const seatGroupIDs = res[0].seats;
            const seatIDsList: IMenuList = {};
            for (const seat of seatGroupIDs || []) {
              seatIDsList[seat.seatID] = {
                title: seat.seatID.toString(),
                selected: (
                  (this.props.deal.SspParams as IIndexExchangeToPublicaApiDeal).seatIDs || []
                ).includes(seat.seatID),
                ID: seat.seatID.toString(),
              };
            }
            this.setState({
              seatIDsList,
            });
          }
        })
        .catch(() => {
          this.setState({
            snackbarMessage: 'Error while getting seat ids.',
            snackbarError: true,
          });
        });
    };

    genContextualSegmentList = () => {
      getContextualSegmentsByPublisherID(this.props.session.publisher.ID)
        .then((resp) => {
          const contextualSegments = resp[0];
          const contextualSegmentList: IMenuList = {};
          for (const segment of contextualSegments || []) {
            if (segment.Active === ResourceActiveDisabled) {
              continue;
            }
            contextualSegmentList[segment.ID] = {
              title: segment.Name,
              selected: this.state.ContextualSegmentIDS.includes(segment.ID),
              ID: segment.ID.toString(),
            };
          }
          this.setState({
            contextualSegmentList,
          });
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'Error loading contextual segments',
          });
        });
    };

    // genSamsungStatusList generates all the Samsung status available for deal.
    // For example, is a deal is between its start/end dates and didn't reached its impression goal, the "RUNNING" status
    // will be available.
    genSamsungStatusList = (): string[] => {
      const { deal } = this.props;
      const { didDealMakeBidRequest } = this.state;
      const possibleChoice: SamsungDealStatus[] = [];
      const dealCurrentStatus = (deal.SspParams as ISamsungDealParams).status;

      // decide which status between RUNNING and PENDING is available
      //   - RUNNING is available when the deal is between its start/end dates and served impressions
      //   - PENDING is available otherwise
      let runningOrPending: SamsungDealStatus = 'PENDING';
      if (
        moment(deal.StartDate).isBefore(moment()) &&
        moment(deal.EndDate).isAfter(moment()) &&
        didDealMakeBidRequest
      ) {
        runningOrPending = 'RUNNING';
      }

      // decide which choice are available (other than selected)
      if (!dealCurrentStatus) {
        // deal status is undefined
        possibleChoice.push(runningOrPending, 'PAUSED', 'STOPPED');
      } else if (dealCurrentStatus === 'RUNNING' || dealCurrentStatus === 'PENDING') {
        // if deal is RUNNING/PENDING
        possibleChoice.push('STOPPED', 'PAUSED');
      } else if (dealCurrentStatus === 'PAUSED') {
        // if deal is PAUSED
        possibleChoice.push(runningOrPending, 'STOPPED');
      } else if (
        dealCurrentStatus === 'STOPPED' &&
        !(deal.SspParams as ISamsungDealParams).isDealStopped
      ) {
        // if deal is STOPPED, but this choice is not SAVED yet
        possibleChoice.push(runningOrPending, 'PAUSED');
      }

      // add the current deal status to the list of possible choice
      if (dealCurrentStatus) {
        possibleChoice.push(dealCurrentStatus);
      }

      return possibleChoice;
    };

    // Handles the change of start and end date in the Unruly's SSP params.
    handleUnrulyDateChange = ({ start, end }: IDateRangeChangeEvent) => {
      // always save the start/end date in UTC
      start = start.utc();
      end = end.utc();

      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          SspParams: {
            ...this.props.deal.SspParams,
            StartDate: start.format(),
            EndDate: end.format(),
          },
        });
      }
    };

    // Handles the change of start and end date in the Deal settings.
    handleDateChange = ({ start, end }: IDateRangeChangeEvent) => {
      if (this.props.onChange) {
        if (!(this.props.deal.BidderType === 'indexExchange')) {
          this.props.onChange({
            ...this.props.deal,
            StartDate: start ? start.format() : '',
            EndDate: end ? end.format() : '',
          });
        } else {
          this.props.onChange({
            ...this.props.deal,
            SspParams: {
              ...this.props.deal.SspParams,
              startDate: start ? start.format('YYYY-MM-DD') : '',
              endDate: end ? end.format('YYYY-MM-DD') : '',
            },
          });
        }
      }
    };

    // Handles the click on the "clear dates" button.
    handleClearDates = () => {
      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          StartDate: '',
          EndDate: '',
          ImpressionGoal: '0',
        });
      }
    };

    // Handles general changes in the deal object.
    handleDealChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          [target.name]: target.value,
        });
      }
    };

    handlePriorityChange = (tierSet: Set<number>) => {
      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          Priority: [...tierSet][0],
        });
      }
    };

    handleChangeBidFloorAndBidFloorCurrency = (bidFloor: string, currency: CurrencyType) => {
      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          BidFloor: bidFloor,
          CurrencyDisplayed: convertStringToECurrencyType(currency),
        });
      }
    };

    // -------- HANDLER FUNCTIONS -------- //
    // NOTE: functions passed into a child component which update state in the parent
    // should be called handleFunc.  They are used to not directly modify the props/state
    // and make sure the parent component is properly re-rendered

    // -------- SETTINGS TOP BAR HANDLER FUNCTIONS -------- //

    // Top bar name change
    handleNameChange = (name: string) => {
      this.props.onChange({ ...this.props.deal, Name: name });
    };

    // Top bar close
    handleClose = (): void => {
      navigate(
        RouteDealList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    };

    // Top bar active change
    handleChangeActive = (): void => {
      // define the new deal object to pass to the parent's onChange handler
      const deal = {
        ...this.props.deal,
        Active:
          this.props.deal.Active === ResourceActiveEnabled
            ? ResourceActiveDisabled
            : ResourceActiveEnabled,
      };

      // if the deal is from Samsung SSP, then we need to apply the active/status logic
      if (deal.BidderType === 'samsungssp') {
        dealActiveStatusChangeHandler(deal);
      }

      // trigger the onChange with the new deal
      this.props.onChange(deal);
    };

    // Top bar save
    handleSave = ({ isSavedFromPopup }: { isSavedFromPopup: boolean }): void => {
      // Convert the deal's start/end date to UTC
      let deal = {
        ...this.props.deal,
        StartDate: this.props.deal.StartDate
          ? moment(this.props.deal.StartDate).utc().format()
          : '',
        EndDate: this.props.deal.EndDate ? moment(this.props.deal.EndDate).utc().format() : '',
      };

      // Validate Bid Floor for Programmatic Guaranteed and Preferred Deal
      let bidFloor: number | null = null;
      if (!isNil(deal.BidFloor) && deal.BidFloor !== '') {
        bidFloor = parseFloat(deal.BidFloor);
      }
      if ([DealType.ProgrammaticGuaranteed, DealType.PreferredDeal].includes(deal.DealType)) {
        if (isNil(deal.BidFloor) || deal.BidFloor === '') {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'Bid Floor is required for Programmatic Guaranteed and Preferred Deal',
          });
          return;
        }
        if (isNaN(bidFloor!) || bidFloor! <= 0) {
          this.setState({
            snackbarError: true,
            snackbarMessage:
              'Bid Floor must be greater than 0 for Programmatic Guaranteed and Preferred Deal',
          });
          return;
        }
      }

      // If needed, open the Samsung warning popup and return. We open the warning popup if the status of the deal is
      // being updated to stopped.
      if (
        deal.BidderType === 'samsungssp' && // deal is Samsung
        !isSavedFromPopup && // user is not saving from the warning popup
        !(deal.SspParams as ISamsungDealParams).isDealStopped && // the deal is not already stopped
        (deal.SspParams as ISamsungDealParams).status === 'STOPPED'
      ) {
        // the user updated the deal to be stopped
        // open the warning popup and return
        this.setState({
          isSamsungPopupOpen: true,
        });
        return;
      }

      // Get the correct key for the test form schema. This defines which key will be used in DealSettingsFormSchema.
      let testFormShemaKey: string = 'sspWithoutAPI'; // Default to SSP without API.
      if (DEAL_SSP_WITH_API_LIST.includes(this.props.deal.BidderType)) {
        testFormShemaKey = this.props.deal.BidderType; // If the SSP has an API, then use its name as a validation form key.
      } else if (this.props.deal.DealType === DealType.ProgrammaticGuaranteed) {
        testFormShemaKey = 'programmaticGuaranteed'; // If the deal is a Programmatic Guaranteed deal, then use the Programmatic Guaranteed validation form key.
      }

      // if the deal is a Samsung deal, handle some things before saving
      if (deal.BidderType === 'samsungssp') {
        // transform/create some values inside the Samsung's deal
        deal = this.samsungDealPresave(deal);
        // check the Samsung's deal targeting
        if (!this.samsungDealTargetingVerification(deal)) {
          return;
        }
      }

      if (moment(this.props.deal.EndDate).isBefore(moment())) {
        this.setState({
          snackbarError: true,
          snackbarMessage: "End Date can't be before now",
        });
        return;
      }

      // Test the user inputs.
      (DealSettingsFormSchema as any)[testFormShemaKey]
        .validate(deal, { abortEarly: false })
        .then(() => {
          // if the deal is a Samsung deal and its status is set to STOPPED, then set it's DSP isDealStopped param
          if (
            deal.BidderType === 'samsungssp' &&
            (deal.SspParams as ISamsungDealParams).status === 'STOPPED'
          ) {
            (deal.SspParams as ISamsungDealParams).isDealStopped = true;
          }
          this.props.onSubmit(deal);
        })
        .catch((err: any) => {
          const errors = err.errors.reduce((memo: any, errorString: string) => {
            const index = errorString.indexOf(' ');
            const path = errorString.substring(0, index);
            memo[path] = errorString.substring(index + 1, errorString.length);
            return memo;
          }, {});
          const snackbarError = true;
          let snackbarMessage = 'Unable to save deal.';

          // Use snackbar to render datetime errors
          if (errors.StartDate) {
            snackbarMessage += ` ${errors.StartDate}`;
          }
          if (errors.EndDate) {
            snackbarMessage += ` ${errors.EndDate}`;
          }

          this.setState({
            errors,
            snackbarError,
            snackbarMessage,
          });
        });
    };

    // Handle when the user click "Yes, save the deal" on the warning popup on Samsung's deal.
    // This popup warn the user when saving a deal with its status = stopped.
    handleSamsungPopupSave = () => {
      this.setState(
        {
          isSamsungPopupOpen: false, // close the popup
        },
        () => {
          // after closing the popup, save the deal
          this.handleSave({ isSavedFromPopup: true }); // let handleSave know we saved the deal from the popup
        },
      );
    };

    // Handle when the user close or click "No, cancel" on the warning popup on Samsung's deal.
    // This popup warn the user when saving a deal with its status = stopped.
    handleSamsungPopupClose = () => {
      this.setState({
        isSamsungPopupOpen: false, // close the popup
      });
    };

    // samsungDealPresave handles some things before saving a Samsung deal.
    samsungDealPresave(deal: IDeal): IDeal {
      // transform deal.sspParams.ecpm - transform string to number and round it to 3 decimal places
      let ecpm = parseFloat((deal.SspParams as ISamsungDealParams).ecpm as string);
      ecpm = Math.round(ecpm * 1000) / 1000;
      if (!isNaN(ecpm)) {
        (deal.SspParams as ISamsungDealParams).ecpm = ecpm;
      }

      // transform deal.sspParams.totalAdvBudget - transform string to number and round it to 2 decimal places
      let totalAdvBudget = parseFloat(
        (deal.SspParams as ISamsungDealParams).totalAdvBudget as string,
      );
      totalAdvBudget = Math.round(totalAdvBudget * 100) / 100;
      if (!isNaN(totalAdvBudget)) {
        (deal.SspParams as ISamsungDealParams).totalAdvBudget = totalAdvBudget;
      }

      // if the deal key (deal ID for Samsung) is not set, then set it to a new random UUID
      if (!deal.DealKey) {
        deal.DealKey = uuid();
      }

      // if deal.ImpressionGoal is a string: remove the thousand comma separator
      if (typeof deal.ImpressionGoal === 'string') {
        deal.ImpressionGoal = deal.ImpressionGoal.replace(/,/g, '');
      }

      // if the saved deal is stopped, also make it inactive
      if ((deal.SspParams as ISamsungDealParams).status === 'STOPPED') {
        deal.Active = ResourceActiveDisabled;
      }

      return deal;
    }

    // samsungDealTargetingVerification checks if a Samsung deal targets at least one channel or one channel group.
    // This function returns true if the targeting is correct, false otherwise.
    // This function handles setting the Snackbar state to display an error message.
    samsungDealTargetingVerification(deal: IDeal): boolean {
      // if the deal doesn't target at least one channel or one channel group, set snackbar error
      if (deal.Channels.length === 0 && deal.ChannelGroups.length === 0) {
        // set snackbar error
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Please target at least one channel or one channel group.',
        });
        return false;
      }
      return true;
    }

    // Top bar delete
    handleDelete = () => {
      this.setState(
        {
          isUpdating: true,
        },
        () => {
          this.props.onDelete(this.props.deal);
        },
      );
      // the delete modal expects a promise to be returned
      return new Promise((resolve) => resolve(undefined));
    };

    handleChannelAcceptClick = (channelList: IMenuList): void => {
      const selectedChannelIDs = Object.values(channelList)
        .filter((listItem: IListItem) => listItem.selected)
        .map((listItem: IListItem) => {
          return parseInt(listItem.ID, 10);
        });

      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          Channels: this.state.Channels.filter((Channel) =>
            selectedChannelIDs.includes(Channel.ID),
          ),
        });
      }
    };

    handleContextualSegmentsAcceptClick = (contextualSegmentList: IMenuList): void => {
      const ContextualSegmentIDS = [] as number[];
      for (const { ID, selected } of Object.values(contextualSegmentList) as IListItem[]) {
        if (selected) {
          ContextualSegmentIDS.push(parseInt(ID, 10));
        }
      }

      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          ContextualSegmentIDS,
        });
      }

      this.setState({
        contextualSegmentList,
      });
    };

    handleBuyerDspSeatIDChange = (value: string, buyerIndex: number): void => {
      const newDeal = { ...this.props.deal };
      const arrays = (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].SeatID
        ? (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].SeatID.split(',')
        : [];
      arrays.push(value);
      (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].SeatID = arrays.join(',');
      this.props.onChange(newDeal);
    };

    handleBuyerAdomainChange = (value: string, buyerIndex: number): void => {
      const newDeal = { ...this.props.deal };
      const arrays = (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].Adomain
        ? (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].Adomain.split(',')
        : [];
      arrays.push(value);
      (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].Adomain = arrays.join(',');
      this.props.onChange(newDeal);
    };

    handleBuyerDspSeatIDDelete = (value: string, buyerIndex: number): void => {
      const newDeal = { ...this.props.deal };
      (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].SeatID = (
        newDeal.SspParams as IUnrulyDealParams
      ).Buyers[buyerIndex].SeatID.split(',')
        .filter((adomain) => adomain !== value)
        .join(',');
      this.props.onChange(newDeal);
    };

    handleBuyerAdomainDelete = (value: string, buyerIndex: number): void => {
      const newDeal = { ...this.props.deal };
      (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].Adomain = (
        newDeal.SspParams as IUnrulyDealParams
      ).Buyers[buyerIndex].Adomain.split(',')
        .filter((adomain) => adomain !== value)
        .join(',');
      this.props.onChange(newDeal);
    };

    handleBuyerActiveChange = (checked: boolean, buyerIndex: number): void => {
      const newDeal = { ...this.props.deal };
      (newDeal.SspParams as IUnrulyDealParams).Buyers[buyerIndex].Active = checked;
      this.props.onChange(newDeal);
    };

    handleAddBuyerClick = (): void => {
      const newDeal = { ...this.props.deal };
      (newDeal.SspParams as IUnrulyDealParams).Buyers.push({
        SeatID: '',
        Adomain: '',
        Active: true,
      } as IUnrulyDealBuyer);
      this.props.onChange(newDeal);
    };

    handleRemoveBuyerClick = (buyerIndex: number): void => {
      const newDeal = { ...this.props.deal };
      (newDeal.SspParams as IUnrulyDealParams).Buyers.splice(buyerIndex, 1);
      this.props.onChange(newDeal);
    };

    applyFloorPriceForAllBuyers = (): void => {
      const newDeal = { ...this.props.deal };
      // Take the floor price of the first buyer.
      const floorPrice = (newDeal.SspParams as IUnrulyDealParams).Buyers[0].BidFloor;
      // Apply this price to all other buyers.
      for (let i = 1; i < (newDeal.SspParams as IUnrulyDealParams).Buyers.length; i++) {
        (newDeal.SspParams as IUnrulyDealParams).Buyers[i].BidFloor = floorPrice;
      }
      this.props.onChange(newDeal);
    };

    // handler for toggle with/without api for ssps with both apis
    handleChangeApiType = (): void => {
      // Create a new deal so that we can bubble up change
      const newDeal = { ...this.props.deal };

      if (newDeal.BidderType.includes('NoApi')) {
        // No API -> with API
        newDeal.BidderType = newDeal.BidderType.slice(
          0,
          newDeal.BidderType.length - 5,
        ) as DealBidderType;

        // clear seat ids when switching to with api
        newDeal.SeatIDs = [];
      } else {
        // With API -> No API
        newDeal.BidderType = (newDeal.BidderType + 'NoApi') as DealBidderType;
      }
      // bubble up event
      this.props.onChange(newDeal);
    };

    handleSiteIDsAcceptClick = (selectedValues: IMenuList): void => {
      const selectedSiteIDs = [] as number[];
      for (const item of Object.values(selectedValues).filter((item: IListItem) => item.selected)) {
        if (parseInt(item.ID, 10)) {
          selectedSiteIDs.push(parseInt(item.ID, 10));
        }
      }

      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          SspParams: {
            ...this.props.deal.SspParams,
            targetingSiteIDs: selectedSiteIDs,
          },
        });
      }

      this.setState({
        siteIDsList: selectedValues,
      });
    };

    handleSeatIDsAcceptClick = (selectedValues: IMenuList): void => {
      const selectedSeatIDs = [] as number[];
      for (const item of Object.values(selectedValues).filter((item: IListItem) => item.selected)) {
        if (parseInt(item.ID, 10)) {
          selectedSeatIDs.push(parseInt(item.ID, 10));
        }
      }

      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          SspParams: {
            ...this.props.deal.SspParams,
            seatIDs: selectedSeatIDs,
          },
        });
      }

      this.setState({
        seatIDsList: selectedValues,
      });
    };

    handleInventoryGroupIDsAcceptClick = (selectedValues: IMenuList): void => {
      const selectedInventoryGroupIDs = [] as number[];
      for (const item of Object.values(selectedValues).filter((item: IListItem) => item.selected)) {
        if (parseInt(item.ID, 10)) {
          selectedInventoryGroupIDs.push(parseInt(item.ID, 10));
        }
      }

      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.deal,
          SspParams: {
            ...this.props.deal.SspParams,
            targetingInventoryGroupIDs: selectedInventoryGroupIDs,
          },
        });
      }

      this.setState({
        inventoryGroupIDsList: selectedValues,
      });
    };

    getAuctionTypeBasedOnOpenMarket = (openMarket: OpenMarket): AuctionType => {
      switch (openMarket) {
        case OpenMarket.PrivateDeal:
          return AuctionType.Fixed;
        case OpenMarket.OpenDeal:
        default:
          return AuctionType.First;
      }
    };

    // a generic form handler for form input elements.
    handleDealFormInputChange = (elem: React.ChangeEvent<HTMLInputElement>): void => {
      const { type, name: path, value, checked } = elem.target;

      let parsedValue;
      switch (type) {
        // for input[type=number] fields
        case 'number':
          parsedValue = parseInt(value, 10);
          break;
        // <Checkbox/> returned a boolean on the checked property of the target
        case 'checkbox':
          parsedValue = checked;
          break;
        // <RadioGroup/> return the value of the <Radio> element
        case 'radio':
          parsedValue = path === 'AudienceTargetingOperationType' ? parseInt(value, 10) : value;
          break;
        // Everything else including <input> fields return strings
        default:
          parsedValue = value;
      }

      if (path === 'SspParams.rate') {
        parsedValue = parseInt(value, 10);
      }

      // Create a new deal so that we can bubble up change
      const newDeal = { ...this.props.deal };

      if (!get(newDeal, 'SspParams.EndDate')) {
        set(newDeal, 'SspParams.EndDate', moment().add(8, 'days').tz('America/New_York').format());
      }

      // special handling when we select "Samsung SSP" as "Partner"
      if (path === 'BidderType' && value === 'samsungssp') {
        // select "Programmatic Guaranteed" as "Deal Type"
        set(newDeal, 'DealType', DealType.ProgrammaticGuaranteed);
        // set the "DSP Partner" field to "Trader"
        set(newDeal, 'SspParams.partnerName', 'trader');
        // set the "Status" field to "pending"
        set(newDeal, 'SspParams.status', 'PENDING');
      }

      // special handling for Partner "Index Exchange" with API
      // setting the openMarket field will also set the auctionType field
      if (path === 'SspParams.openMarket') {
        set(
          newDeal,
          'SspParams.auctionType',
          this.getAuctionTypeBasedOnOpenMarket(parsedValue as OpenMarket),
        );
      }

      // set the openMarket and auctionType correctly when changing Partner to "Index Exchange"
      // set the default openMarket to "Private Deal" if not set (same as in renderOpenMarketInput)
      if (path === 'BidderType' && value === 'indexExchange') {
        if (!get(newDeal, 'SspParams.openMarket')) {
          set(newDeal, 'SspParams.openMarket', OpenMarket.PrivateDeal);
          set(
            newDeal,
            'SspParams.auctionType',
            this.getAuctionTypeBasedOnOpenMarket(OpenMarket.PrivateDeal),
          );
        } else {
          set(
            newDeal,
            'SspParams.auctionType',
            this.getAuctionTypeBasedOnOpenMarket(
              get(newDeal, 'SspParams.openMarket', OpenMarket.PrivateDeal) as OpenMarket,
            ),
          );
        }
      }

      // SeatIDs handling
      if (path === 'SeatIDs') {
        if (String(parsedValue).trim() === '') {
          // clear seat IDs array if the input is empty
          parsedValue = null;
        } else {
          parsedValue = String(parsedValue)
            .split(',')
            .map((seatID: string) => seatID.trim());
        }
      }

      // clear SeatIDs if DealType is OpenAuction
      if (path === 'DealType' && parsedValue === DealType.OpenAuction) {
        set<IDeal>(newDeal, 'SeatIDs', null);
      }

      // automatically set Deal Tier to 1 if DealType is ProgrammaticGuaranteed
      if (path === 'DealType' && parsedValue === DealType.ProgrammaticGuaranteed) {
        set<IDeal>(newDeal, 'Priority', 10);
      }

      // path can be a top level deal property like "Name" for Deal.Name or go deeper such as
      // "SspParams.PackageID" for Deal.SspParams.PackageID
      set<IDeal>(newDeal, path, parsedValue);

      // set defaults for values so that their API won't break
      if (path === 'BidderType' && (value === 'indexExchange' || value === 'rhythmone')) {
        if (!get(newDeal, 'SspParams.startDate')) {
          set(
            newDeal,
            'SspParams.startDate',
            moment().add(1, 'days').tz('America/New_York').format(),
          );
        }

        if (!get(newDeal, 'SspParams.endDate')) {
          set(
            newDeal,
            'SspParams.endDate',
            moment().add(8, 'days').tz('America/New_York').format(),
          );
        }
      }

      // If this path is in the errors object, remove it because it's being modified
      this.setState({
        errors: omit(this.state.errors, [path]),
        shouldRefreshDealPrioritySelect:
          path === 'DealType' && parsedValue === DealType.ProgrammaticGuaranteed,
      });

      // bubble up event
      this.props.onChange(newDeal);
      if (path === 'SspParams.dspID') {
        this.loadIndexExchangeSeatIDs(Number(value));
      }
    };

    // -------- Render Functions -------- //

    // define tabs and corresponding render functions
    renderTabs = (): ReactElement => {
      const tabs: ITab[] = [
        {
          label: 'Deal',
          render: this.renderDealTab,
        },
        {
          label: 'Targeting',
          render: this.renderTargetingTab,
        },
      ];

      return (
        <SettingsTabs
          tabs={tabs}
          marginTop={0} // no top margin needed to clear the top bar because the live-data renderer is handling it
        />
      );
    };

    handleChangeSalesperson = (salespersonIDs: string[]): void => {
      const newSalespersonID = salespersonIDs.length ? parseInt(salespersonIDs[0], 10) || 0 : 0;
      this.props.onChange({
        ...this.props.deal,
        SalespersonID: newSalespersonID,
      });
    };

    // renders deal tab
    renderDealTab = (): ReactElement => {
      const { classes, deal } = this.props;
      const { errors } = this.state;

      // is the deal an existing deal with a third-party API
      const isDealExistingThirdParty =
        DEAL_SSP_WITH_API_LIST.includes(deal.BidderType) && deal.ID > 0;

      return (
        <>
          {/* Deal Tab */}
          <Grid className={classes.mainGridItem} style={{ padding: '16px 24px' }}>
            <ModelPrimaryContainer container direction='column' justify='space-between'>
              <HeadingCategory>Details</HeadingCategory>
              <Grid
                container
                justifyContent='flex-start'
                alignItems='center'
                style={{ paddingBottom: 18 }}
                spacing={2}
              >
                <Grid
                  item
                  xs={8}
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
                >
                  <FormLabel style={{ display: 'inline-block', marginTop: -3, paddingRight: 8 }}>
                    ID
                  </FormLabel>
                  <Grid item style={{ width: '360px' }}>
                    <Text>{deal.ID}</Text>
                  </Grid>
                </Grid>
              </Grid>

              {deal.BidderType === 'indexExchange' && (
                <Grid
                  container
                  justifyContent='flex-start'
                  alignItems='center'
                  style={{ paddingBottom: 30, minWidth: '400px' }}
                  spacing={2}
                >
                  <Grid
                    item
                    xs={8}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      minWidth: '400px',
                    }}
                  >
                    <FormLabel style={{ minWidth: '120px' }}>{ct('Name')}</FormLabel>
                    <Grid item style={{ width: '360px' }}>
                      <TextField
                        label=''
                        name='SspParams.name'
                        fullWidth
                        value={(deal.SspParams as IIndexExchangeToPublicaApiDeal).name}
                        onChange={this.handleDealFormInputChange}
                        disabled={false}
                        error={!!get(errors, 'SspParams.name', false)}
                        helperText={((): string | undefined => {
                          if (get(errors, 'SspParams.name', false)) {
                            return `Name ${get(errors, 'SspParams.name', false)}`; // validation error
                          }
                          return undefined; // no helper text
                        })()}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}

              <Grid
                container
                justifyContent='flex-start'
                alignItems='center'
                style={{ paddingBottom: 18 }}
                spacing={2}
              >
                <Grid
                  item
                  xs={4}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    padding: 8,
                    minWidth: '400px',
                  }}
                >
                  <FormLabel style={{ minWidth: '120px' }}>{ct('Salesperson')}</FormLabel>
                  <UserMultiSelect
                    onChange={this.handleChangeSalesperson}
                    publisherID={this.props.session.publisher.ID}
                    enableMultiSelect={false}
                    userIDs={deal.SalespersonID ? [String(deal.SalespersonID)] : []}
                    username={this.props.user.user.Username}
                    fontSize='16px'
                  />
                </Grid>
              </Grid>

              <Grid
                container
                justifyContent='flex-start'
                alignItems='center'
                style={{ paddingBottom: 10 }}
                spacing={2}
              >
                <Grid
                  item
                  xs={4}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    minWidth: '400px',
                  }}
                >
                  <FormLabel style={{ minWidth: '120px' }}>{ct('Partner')}</FormLabel>
                  <DealBidderTypeSelect
                    publisher={this.props.session.publisher}
                    name='BidderType'
                    fullWidth
                    value={deal.BidderType === '' ? '' : getDealBidderType(deal.BidderType)}
                    onChange={this.handleDealFormInputChange}
                    error={get(errors, 'BidderType', false)}
                    disabled={isDealExistingThirdParty}
                    helperText={((): string | undefined => {
                      if (get(errors, 'BidderType', false)) {
                        return `Partner ${get(errors, 'BidderType', false)}`; // form validation error
                      }
                      return undefined; // no helper text
                    })()}
                  />
                </Grid>

                {deal.BidderType !== '' &&
                  DEAL_SSP_BOTH_LIST.some((ssp) => deal.BidderType.includes(ssp)) && (
                    <Grid
                      item
                      xs={8}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <Text small muted={deal.BidderType.includes('NoApi')}>
                        With API
                      </Text>
                      <Switch
                        name='EnableSaveCreativeValidations'
                        title='With API'
                        checked={!deal.BidderType.includes('NoApi')}
                        onChange={this.handleChangeApiType}
                      />
                      {!this.state.tokenStatus && deal.BidderType === 'indexExchange' && (
                        <Cols
                          extraSmallVerticalPadding
                          smallHorizontalPadding
                          style={{
                            backgroundColor: adminDebugColor,
                            borderRadius: smallRadius,
                            width: 'fit-content',
                            height: 'fit-content',
                          }}
                        >
                          <Col paddingRight='4px'>
                            <IconV2 small name='info' color={publicaColors.mediumGray} />
                          </Col>
                          <Col>
                            <Text extraSmall muted>
                              Index Exchange login authentication is valid for 8 hours only. Please
                              provide credentials{' '}
                              <a
                                href={
                                  '#' +
                                  getRoutePath(
                                    RouteDealTPAccountList,
                                    extractRouteParams(this.props),
                                  )
                                }
                              >
                                here
                              </a>{' '}
                              to continue.
                            </Text>
                          </Col>
                        </Cols>
                      )}
                    </Grid>
                  )}
              </Grid>

              <Grid container direction='column' style={{ paddingBottom: 18 }} spacing={2}>
                {/* Deal ID for SSP with an API */}
                {DEAL_SSP_WITH_API_LIST.includes(deal.BidderType) &&
                  deal.BidderType !== 'indexExchange' && (
                    <Grid item xs={4} style={{ minWidth: '400px' }}>
                      <TextField
                        fullWidth
                        name='DealKey'
                        label='Deal ID (Will be populated shortly after you save)'
                        placeholder='(Will be populated shortly after you save)'
                        value={deal.DealKey}
                        disabled={true}
                      />
                    </Grid>
                  )}
                {/* Deal ID required field named dealID, conditional logic might have to change dynamically if future biddertypes also use dealID */}
                {deal.BidderType === 'indexExchange' && (
                  <Grid item xs={4} style={{ minWidth: '400px' }}>
                    {this.renderDealIDInput(deal, errors, this.state.didDealMakeBidRequest)}
                  </Grid>
                )}

                {/* ONLY FOR INDEX EXCHANGE WITH API */}
                {DEAL_SSP_WITH_API_LIST.includes(deal.BidderType) &&
                  deal.BidderType === 'indexExchange' && (
                    <Grid item xs={4} style={{ minWidth: '400px' }}>
                      {this.renderOpenMarketInput(deal)}
                    </Grid>
                  )}

                {/* Deal ID field for SSPs without an API */}
                {DEAL_SSP_WITHOUT_API_LIST.includes(deal.BidderType) && (
                  <>
                    <Grid item xs={4} style={{ minWidth: '400px' }}>
                      <TextField
                        fullWidth
                        name='DealKey'
                        label='Deal ID'
                        placeholder='Please insert the provided deal key here'
                        onChange={this.handleDealFormInputChange}
                        value={deal.DealKey}
                        error={!!get(errors, 'DealKey', false)}
                      />
                    </Grid>
                    {deal.DealType !== DealType.OpenAuction && (
                      <Grid item xs={4} style={{ minWidth: '400px' }}>
                        <TextField
                          fullWidth
                          name='SeatIDs'
                          label={ct('SeatID')}
                          placeholder={ct('CanBeCommaSeparated')}
                          onChange={this.handleDealFormInputChange}
                          value={deal.SeatIDs ? deal.SeatIDs.join(',') : ''}
                          error={!!get(errors, 'SeatIDs', false)}
                        />
                      </Grid>
                    )}
                  </>
                )}

                {/* Deal Type */}
                <Grid item xs={4} style={{ minWidth: '400px', paddingTop: '10px' }}>
                  {deal.BidderType !== '' &&
                    deal.BidderType !== 'indexExchange' &&
                    this.renderDealTypeInput(deal, errors)}
                </Grid>
              </Grid>

              {deal.BidderType === 'indexExchange' && (
                <Grid container justifyContent='flex-start' alignItems='center' spacing={2}>
                  <Grid item xs={4} style={{ minWidth: '400px', paddingBottom: 28 }}>
                    {this.renderSiteIDInput()}
                  </Grid>
                  <Grid item xs={4} style={{ minWidth: '400px', paddingBottom: 28 }}>
                    {this.renderInventoryIDInput()}
                  </Grid>
                </Grid>
              )}

              {/* ONLY FOR UNRULY, form for deal name, description, inventory package, dates and deal type */}
              {deal.BidderType === 'rhythmone' && (
                <Grid
                  container
                  justifyContent='flex-start'
                  alignItems='center'
                  style={{ paddingBottom: 18 }}
                  spacing={2}
                >
                  <Grid item xs={4} style={{ minWidth: '400px' }}>
                    <TextField
                      required
                      fullWidth
                      label='Deal Name'
                      name='Name'
                      value={deal.Name}
                      onChange={this.handleDealFormInputChange}
                      error={get(errors, 'Name', false)}
                      helperText={
                        get(errors, 'Name', false) ? `Deal Name ${get(errors, 'Name', false)}` : ''
                      }
                    />
                    {/* Deal name error message */}
                    {deal.Name === '' && (
                      <p style={{ color: 'red', margin: '0px' }}>Deal name is required.</p>
                    )}
                  </Grid>
                  {/* Description */}
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label='Description'
                      name='SspParams.Description'
                      value={(deal.SspParams as IUnrulyDealParams).Description}
                      onChange={this.handleDealFormInputChange}
                    />
                  </Grid>
                  {/* Deal Type*/}
                  <Grid item xs={4}>
                    {deal.BidderType.length > 0 && this.renderDealTypeInput(deal, errors)}
                  </Grid>
                  {/* Start End Dates */}
                  <Grid item xs={12}>
                    {this.renderFlightDates(deal)}
                  </Grid>
                </Grid>
              )}

              {/* ONLY FOR NON-API DEALS AND SAMSUNG, form for the deal type */}
              {(DEAL_SSP_WITHOUT_API_LIST.includes(deal.BidderType) ||
                deal.BidderType === 'samsungssp') && (
                <Grid
                  container
                  justifyContent='flex-start'
                  alignItems='center'
                  style={{ paddingBottom: 18 }}
                  spacing={2}
                ></Grid>
              )}

              {/* ONLY FOR NON-API DEALS AND SAMSUNG, Deal flight dates */}
              {(DEAL_SSP_WITHOUT_API_LIST.includes(deal.BidderType) ||
                deal.BidderType === 'samsungssp') &&
                this.renderFlightDates(deal)}

              {/* ONLY FOR INDEXEXCHANGE, Deal flight dates */}
              {DEAL_SSP_WITH_API_LIST.includes(deal.BidderType) &&
                deal.BidderType === 'indexExchange' &&
                this.renderSspParamsFlightDates(deal)}

              {/* ONLY FOR NON-API DEALS AND SAMSUNG, impression goal */}
              {(DEAL_SSP_WITHOUT_API_LIST.includes(deal.BidderType) ||
                deal.BidderType === 'samsungssp') &&
                this.renderImpressionGoal(deal)}

              {/* conditional might have to change if new deals similar to indexExchange is made */}
              {deal.BidderType !== '' &&
                deal.BidderType !== 'indexExchange' &&
                this.renderBidFloor(deal)}
              {deal.BidderType === 'indexExchange' && this.renderRateInput(deal)}

              {/* ONLY FOR INDEX EXCHANGE WITH API */}
              {DEAL_SSP_WITH_API_LIST.includes(deal.BidderType) &&
                deal.BidderType === 'indexExchange' && (
                  <Grid item xs={4} style={{ marginBottom: '12px' }}>
                    {this.renderPriorityInput(deal)}
                  </Grid>
                )}
              {/* ONLY FOR INDEX EXCHANGE WITH API */}
              {DEAL_SSP_WITH_API_LIST.includes(deal.BidderType) &&
                deal.BidderType === 'indexExchange' && (
                  <Grid item xs={4} style={{ marginBottom: '12px' }}>
                    {this.renderPayoutInput(deal)}
                  </Grid>
                )}
              <Div smallVerticalPadding>
                <DealPrioritySelect
                  deal={deal}
                  handlePriorityChange={this.handlePriorityChange}
                  isDisabled={deal.DealType === DealType.ProgrammaticGuaranteed}
                  publisherID={this.props.session.publisher.ID}
                  selectedTier={this.props.deal.Priority}
                  shouldRefresh={this.state.shouldRefreshDealPrioritySelect}
                />
              </Div>
            </ModelPrimaryContainer>

            {/* FORM FOR SAMSUNG */}
            {deal.BidderType === 'samsungssp' && this.renderSamsungParams(deal)}

            {/* FORM FOR UNRULY */}
            {deal.BidderType === 'rhythmone' &&
              deal.DealType !== undefined &&
              (deal.SspParams as IUnrulyDealParams).Buyers.map(
                (buyer: IUnrulyDealBuyer, buyerIndex: number) => (
                  <ModelPrimaryContainer container justify='space-between'>
                    <HeadingCategory>
                      {/* Open Auction titles */}
                      {deal.DealType === DealType.OpenAuction && buyerIndex === 0 && (
                        <>Open Auction Buyer</>
                      )}
                      {deal.DealType === DealType.OpenAuction && buyerIndex > 0 && (
                        <>Additional Buyers</>
                      )}
                      {/* Preferred titles */}
                      {deal.DealType === DealType.PreferredDeal && buyerIndex === 0 && (
                        <>Preferred Buyer</>
                      )}
                      {deal.DealType === DealType.PreferredDeal && buyerIndex > 0 && (
                        <>Non-Preferred Buyers</>
                      )}
                    </HeadingCategory>
                    <Grid container direction='column' justifyContent='center' alignItems='center'>
                      {/* Active switch for buyer */}
                      <Grid
                        item
                        style={{ textAlign: 'right', width: '85%', marginBottom: '-10px' }}
                      >
                        {!(deal.DealType === DealType.PreferredDeal && buyerIndex === 0) && (
                          <>
                            Active
                            <Switch
                              checked={buyer.Active}
                              onChange={(_event, checked) =>
                                this.handleBuyerActiveChange(checked, buyerIndex)
                              }
                              color='secondary'
                            />
                          </>
                        )}
                      </Grid>
                      {/* Buyer form*/}
                      <Grid item style={{ width: 'inherit' }}>
                        <Grid
                          container
                          justify='space-between'
                          alignItems='center'
                          style={{ paddingBottom: 18 }}
                          spacing={2}
                        >
                          <Grid item xs={6}>
                            <UnrulyDSPTargetingSelect
                              name={`SspParams.Buyers[${buyerIndex}].DspID`}
                              label='Buyers DSP'
                              onChange={this.handleDealFormInputChange}
                              publisherID={this.props.session.publisher.ID}
                              value={buyer.DspID}
                              error={get(errors, `SspParams.Buyers[${buyerIndex}].DspID`, false)}
                              helperText={
                                get(errors, `SspParams.Buyers[${buyerIndex}].DspID`, false)
                                  ? `Buyers DSP ${get(
                                      errors,
                                      `SspParams.Buyers[${buyerIndex}].DspID`,
                                      false,
                                    )}`
                                  : ''
                              }
                            />
                            {/* Buyer DPS = Xandr error message*/}
                            {buyer.DspID === 5131 && (
                              <p style={{ color: 'red', margin: '0px' }}>
                                Please contact your Unruly AM in order to receive the correct deal
                                ID to be sent to the buyer.
                              </p>
                            )}
                            {/* 2 buyers with the same DSP error message*/}
                            {(deal.SspParams as IUnrulyDealParams).Buyers.filter(
                              (b: IUnrulyDealBuyer) =>
                                b.DspID === buyer.DspID && b.SeatID === buyer.SeatID,
                            ).length > 1 && (
                              <p style={{ color: 'red', margin: '0px' }}>
                                This Buyer DSP is already selected with the same seat ID. Please
                                choose another Buyer DSP or change the seat ID.
                              </p>
                            )}
                          </Grid>
                          <Grid item xs={6}>
                            <ChipInput
                              fullWidth
                              placeholder='Type and press enter to add a DSP seat ID'
                              label='Buyer DSP seat ID'
                              value={buyer.SeatID.length > 0 ? buyer.SeatID.split(',') : []}
                              onAdd={(v: string) => this.handleBuyerDspSeatIDChange(v, buyerIndex)}
                              onDelete={(v: string) =>
                                this.handleBuyerDspSeatIDDelete(v, buyerIndex)
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <ChipInput
                              fullWidth
                              placeholder='Type and press enter to add an adomain'
                              fullWidthInput={true}
                              label='Buyer Adomain (optional)'
                              value={buyer.Adomain.length > 0 ? buyer.Adomain.split(',') : []}
                              onAdd={(v: string) => this.handleBuyerAdomainChange(v, buyerIndex)}
                              onDelete={(v: string) => this.handleBuyerAdomainDelete(v, buyerIndex)}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label='Bid Floor'
                              type='number'
                              disabled={(deal.SspParams as IUnrulyDealParams).UseSupplyFloor}
                              name={`SspParams.Buyers[${buyerIndex}].BidFloor`}
                              value={buyer.BidFloor}
                              onChange={this.handleDealFormInputChange}
                            >
                              <MenuItem value='1'>Test 1</MenuItem>
                              <MenuItem value='2'>Test 2</MenuItem>
                              <MenuItem value='3'>Test 3</MenuItem>
                            </TextField>
                            {/* Negative bid floor error message*/}
                            {!(deal.SspParams as IUnrulyDealParams).UseSupplyFloor &&
                              buyer.BidFloor < 0 && (
                                <p style={{ color: 'red', margin: '0px' }}>
                                  Minimum bid floor / price allowed is 0.
                                </p>
                              )}
                            {/* Bid floor above 999 error message*/}
                            {!(deal.SspParams as IUnrulyDealParams).UseSupplyFloor &&
                              buyer.BidFloor > 999 && (
                                <p style={{ color: 'red', margin: '0px' }}>
                                  Maximum bid floor / price allowed is 999.
                                </p>
                              )}
                          </Grid>
                        </Grid>
                        <Grid container direction='row-reverse' justify='flex-start'>
                          {buyerIndex === 0 && (
                            <Grid item xs={6}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={(deal.SspParams as IUnrulyDealParams).UseSupplyFloor}
                                    name='SspParams.UseSupplyFloor'
                                    onChange={this.handleDealFormInputChange}
                                  />
                                }
                                label='Use supply floor'
                                labelPlacement='end'
                              />
                            </Grid>
                          )}
                        </Grid>
                        {/* Apply floor price for all buyers*/}
                        <Grid container direction='row-reverse' justify='flex-start'>
                          {buyerIndex === 0 &&
                            (deal.SspParams as IUnrulyDealParams).Buyers.length > 1 && (
                              <Grid item xs={6}>
                                <Button
                                  variant='contained'
                                  color='primary'
                                  onClick={() => this.applyFloorPriceForAllBuyers()}
                                >
                                  Apply floor price for all buyers
                                </Button>
                              </Grid>
                            )}
                        </Grid>
                        <Grid
                          container
                          direction='row'
                          justify='space-between'
                          alignItems='flex-start'
                          style={{ padding: '10px' }}
                        >
                          <Grid item>
                            {buyerIndex ===
                              (deal.SspParams as IUnrulyDealParams).Buyers.length - 1 && (
                              <Button
                                variant='contained'
                                color='primary'
                                onClick={() => this.handleAddBuyerClick()}
                              >
                                {buyerIndex === 0 && <>Add additional buyers (optional)</>}
                                {buyerIndex > 0 && <>Add More</>}
                              </Button>
                            )}
                          </Grid>
                          <Grid item>
                            {buyerIndex > 0 && (
                              <Button
                                variant='contained'
                                color='primary'
                                onClick={() => this.handleRemoveBuyerClick(buyerIndex)}
                              >
                                Remove
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ModelPrimaryContainer>
                ),
              )}

            {/* FORM FOR UNRULY */}
            {deal.BidderType === 'rhythmone' && (
              <ModelPrimaryContainer container justify='space-between'>
                <HeadingCategory>Delivery</HeadingCategory>
                <Grid
                  container
                  justify='flex-start'
                  alignItems='center'
                  style={{ paddingBottom: 18 }}
                  spacing={2}
                >
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label='Overall Impression Limit'
                      type='number'
                      name='SspParams.OverallImpressionLimit'
                      value={(deal.SspParams as IUnrulyDealParams).OverallImpressionLimit}
                      onChange={this.handleDealFormInputChange}
                    ></TextField>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label='Daily Request Limit'
                      type='number'
                      name='SspParams.DailyRequestLimit'
                      value={(deal.SspParams as IUnrulyDealParams).DailyRequestLimit}
                      onChange={this.handleDealFormInputChange}
                    ></TextField>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label='Daily Impression Limit'
                      type='number'
                      name='SspParams.DailyImpressionLimit'
                      value={(deal.SspParams as IUnrulyDealParams).DailyImpressionLimit}
                      onChange={this.handleDealFormInputChange}
                    ></TextField>
                  </Grid>
                  {/* <Grid item xs={4}>*/}
                  {/*  <TextField*/}
                  {/*    fullWidth*/}
                  {/*    label='Dayparting'*/}
                  {/*    select*/}
                  {/*    disabled={true}*/}
                  {/*    name='SspParams.Dayparting'*/}
                  {/*    value={(deal.SspParams as IUnrulyDealParams).Dayparting}*/}
                  {/*    onChange={this.handleDealFormInputChange}>*/}
                  {/*    <MenuItem value='1'>Dayparting 1</MenuItem>*/}
                  {/*  </TextField>*/}
                  {/* </Grid>*/}

                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={(deal.SspParams as IUnrulyDealParams).EnableDealPacing}
                          name='SspParams.EnableDealPacing'
                          onChange={this.handleDealFormInputChange}
                        />
                      }
                      label='Enable Deal Pacing'
                      labelPlacement='end'
                    />
                    <Tooltip
                      title='Enable to pace requests evenly across the day (based on daily request limit).'
                      placement='top-start'
                    >
                      <InfoIcon
                        style={{
                          verticalAlign: 'middle',
                          width: '1rem',
                          color: '#929599',
                          marginLeft: '-10px',
                        }}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              </ModelPrimaryContainer>
            )}

            {/* FORM FOR INDEX EXCHANGE */}
            {deal.BidderType === 'indexExchange' && deal.DealType !== undefined && (
              <ModelPrimaryContainer container justify='space-between'>
                <Panel>
                  <Rows>
                    <Row extraSmallPadding>
                      <Text subheader>Auction Buyers</Text>
                    </Row>
                    <Cols>
                      <Col>
                        <Row
                          extraSmallHorizontalPadding
                          noVerticalPadding
                          style={{
                            width: '300px',
                          }}
                        >
                          {this.renderIndexExchangeBuyerDspInput(
                            deal,
                            (deal.SspParams as IIndexExchangeToPublicaApiDeal).dspID,
                            errors,
                          )}
                        </Row>
                      </Col>
                      <Col>
                        <Row
                          extraSmallHorizontalPadding
                          noVerticalPadding
                          marginBottom='12px'
                          style={{
                            width: '300px',
                          }}
                        >
                          {this.renderSeatIDInput()}
                        </Row>
                      </Col>
                    </Cols>
                    <Row extraSmallHorizontalPadding noVerticalPadding marginBottom='12px'>
                      {this.renderHumanVerificationInput(deal)}
                    </Row>
                  </Rows>
                </Panel>
              </ModelPrimaryContainer>
            )}
          </Grid>
        </>
      );
    };

    // render the deal's targeting tab
    renderTargetingTab = (): ReactElement => {
      const { audienceSegments, classes, deal } = this.props;
      const { writeAuthorization, readAuthorization } = this.state;

      // disable targeting editing once the deal has served OR if a Samsung deal has its status stopped
      const isEditDisabled =
        deal.BidderType === 'samsungssp' && (deal.SspParams as ISamsungDealParams).isDealStopped;

      return (
        <>
          {/* Targeting Tab */}
          <Grid className={classes.mainGridItem}>
            <ModelPrimaryContainer container direction='column' justify='space-between'>
              <HeadingCategory>Inventory</HeadingCategory>
              <Grid container>
                {/* Channel Dropdown */}
                <Grid item style={{ width: '100%', marginBottom: 32 }}>
                  <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='center'
                    spacing={1}
                  >
                    <Grid item xs={2}>
                      <Typography>Channels</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      {/* Empty grid for spacing */}
                    </Grid>
                    <Grid item xs={9}>
                      <MaterialSearchDropdownMulti
                        getValueFromSearchElement={(src: IListItem) => src.title}
                        fontSize='14px'
                        selectAll={true}
                        menuTitle='Channels'
                        menuTitleOverride={
                          deal.BidderType === 'samsungssp' ? 'None' : 'Select Channels'
                        }
                        helperText='Select specific channels to filter on'
                        list={this.state.channelList}
                        disabled={!readAuthorization.isAuthorized || isEditDisabled}
                        onChange={(list: IMenuList) => {
                          this.setState({
                            channelList: list,
                          });
                        }}
                        handleMenuAcceptClick={this.handleChannelAcceptClick}
                        showPrefixID
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* Channel Group Dropdown */}
                <Grid item style={{ width: '100%', marginBottom: 25 }}>
                  <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='flex-end'
                    spacing={1}
                  >
                    <Grid item xs={2}>
                      <Typography>Channel Groups</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      {/* Empty grid for spacing */}
                    </Grid>
                    <Grid item xs={9}>
                      <ChannelGroupTargetingMultiSelect
                        name='ChannelGroups'
                        menuTitleOverride={
                          deal.BidderType === 'samsungssp' ? 'None' : 'Select Channel Groups'
                        }
                        helperText='Select specific channel groups to filter on'
                        onChange={this.handleDealFormInputChange}
                        publisherID={this.props.session.publisher.ID}
                        value={deal.ChannelGroups}
                        disabled={!writeAuthorization.isAuthorized || isEditDisabled}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                <Grid item xs={2}>
                  <Typography>Audience Segments</Typography>
                </Grid>
                <Grid item xs={1}>
                  <ConfirmationDialogButton
                    title='Targeting Change'
                    description={makeTargetingChangeDescription(
                      deal.AudienceTargetingRelationshipType !== EAllowStatus.DENY,
                    )}
                    triggerComponentInfo={makeTargetingChangeInfoHover(
                      deal.AudienceTargetingRelationshipType !== EAllowStatus.DENY,
                    )}
                    acceptButtonTitle='Confirm'
                    acceptButtonCallBack={() =>
                      this.handleDealFormInputChange({
                        target: {
                          name: 'AudienceTargetingRelationshipType',
                          value: reverseEAllowStatus(deal.AudienceTargetingRelationshipType) as any,
                        },
                      } as any)
                    }
                    refuseButtonTitle='Cancel'
                    disabled={!writeAuthorization.isAuthorized || isEditDisabled}
                  >
                    <IconButton>
                      {deal.AudienceTargetingRelationshipType !== EAllowStatus.DENY ? (
                        <CheckIcon style={{ color: publicaColors.green }} />
                      ) : (
                        <BlockIcon style={{ color: publicaColors.red }} />
                      )}
                    </IconButton>
                  </ConfirmationDialogButton>
                </Grid>
                <Grid item xs={6}>
                  <AudienceSegmentTargetingMultiSelect
                    name='AudienceTargeting'
                    audienceSegments={audienceSegments}
                    menuTitleOverride='None'
                    helperText='Select specific audience segments to filter on'
                    onChange={this.handleDealFormInputChange}
                    publisherID={this.props.session.publisher.ID}
                    value={deal.AudienceTargeting}
                    disabled={!writeAuthorization.isAuthorized || isEditDisabled}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControl component='fieldset'>
                    <RadioGroup
                      row
                      aria-label='position'
                      defaultValue='top'
                      name='AudienceTargetingOperationType'
                      value={deal.AudienceTargetingOperationType}
                      onChange={this.handleDealFormInputChange}
                    >
                      <Tooltip title='Targeted request can be in any chosen segment'>
                        <FormControlLabel
                          disabled={!writeAuthorization.isAuthorized || isEditDisabled}
                          value={SegmentTargetingOR}
                          control={<Radio color='primary' />}
                          label={<Typography className={classes.formControlLabel}>Or</Typography>}
                          labelPlacement='top'
                        />
                      </Tooltip>
                      <Tooltip title='Targeted request must be in every chosen segment'>
                        <FormControlLabel
                          disabled={!writeAuthorization.isAuthorized || isEditDisabled}
                          value={SegmentTargetingAND}
                          checked={deal.AudienceTargetingOperationType === SegmentTargetingAND}
                          control={<Radio color='primary' />}
                          label={<Typography className={classes.formControlLabel}>And</Typography>}
                          labelPlacement='top'
                        />
                      </Tooltip>
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {/* Contextual Segment Dropdown */}
                <Grid item style={{ width: '100%', marginBottom: 32 }}>
                  <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='center'
                    spacing={1}
                  >
                    <Grid item xs={2}>
                      <Typography>Contextual Segment</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      {/* Empty grid for spacing */}
                    </Grid>
                    <Grid item xs={9}>
                      <MaterialSearchDropdownMulti
                        getValueFromSearchElement={(src: IListItem) => src.title}
                        enableMultiSelect={false}
                        selectLimit={1}
                        menuTitle='Contextual Segments'
                        list={this.state.contextualSegmentList}
                        disabled={!writeAuthorization.isAuthorized || isEditDisabled}
                        onChange={(contextualSegmentList: IMenuList) =>
                          this.setState({ contextualSegmentList })
                        }
                        handleMenuAcceptClick={this.handleContextualSegmentsAcceptClick}
                        isNoneSelectedAllSelected={false}
                        helperText='Choose which contextual segment to bid on.'
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ModelPrimaryContainer>
          </Grid>
        </>
      );
    };

    // render the live data, between the top bar and the page content
    renderLiveData = (): ReactElement => {
      // get variables from props
      const { deal } = this.props;

      // don't show live-data if the deal doesn't already exist
      if (!deal.ID) {
        // return a margin of 75px to prevent the top of the page content to be hidden under the top bar
        return (
          <div style={{ marginTop: 75 }}>
            <></>
          </div>
        );
      }

      // deal exists, show live-data
      return (
        <Grid style={{ marginTop: 75, marginLeft: 30 }}>
          <LiveData
            deals={[deal]}
            resourceIDs={deal.ID}
            resourceType={'Deal'}
            timezone={this.props.session.publisher.Timezone}
            publisher={this.props.session.publisher}
            userInfo={this.props.user.user}
          />
        </Grid>
      );
    };

    render() {
      // get variables from props/state
      const { snackbarMessage, writeAuthorization, isUpdating, snackbarError, readAuthorization } =
        this.state;
      const { user, classes, session, location, cloneUrl, deal } = this.props;
      const { pathname } = location;

      // render missing permission error messages
      if (isExistingDeal(deal) && !readAuthorization.isAuthorized) {
        return (
          <div style={{ marginLeft: '36px', marginTop: '20px' }}>
            <ModelMissingPermission missingPermissions={readAuthorization.missingPermissions} />
          </div>
        );
      } else if (!writeAuthorization.isAuthorized) {
        return (
          <div style={{ marginLeft: '36px', marginTop: '20px' }}>
            <ModelMissingPermission missingPermissions={writeAuthorization.missingPermissions} />
          </div>
        );
      }

      // render deal form view
      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel largeHorizontalPadding verticalPadding>
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel>
            {/* TOP BAR*/}
            <SettingsAppBar
              name={checkUserInfoMasked(user.user) ? 'demo_deal_' + deal.ID : deal.Name}
              isActive={deal.Active === ResourceActiveEnabled}
              hasWriteRights={writeAuthorization.isAuthorized}
              isUpdating={isUpdating}
              resourceID={deal.ID}
              handleNameChange={this.handleNameChange}
              handleSave={this.handleSave}
              handleClose={this.handleClose}
              handleDelete={deal && deal.ID && this.handleDelete}
              cloneUrl={cloneUrl}
              handleChangeActive={this.handleChangeActive}
              // disable saving and active switch if the deal is Samsung and is stopped
              disableSave={
                deal.BidderType === 'samsungssp' &&
                (deal.SspParams as ISamsungDealParams).isDealStopped
              }
              disableActive={
                deal.BidderType === 'samsungssp' &&
                (deal.SspParams as ISamsungDealParams).isDealStopped
              }
              relative
            />
          </Panel>
          {!isExistingDeal(deal) ? ( // Allow scrolling for existing deals not new ones
            <Panel>
              {/* PAGE CONTENT*/}
              {/* Nav Tabs*/}
              <Grid container direction='column'>
                {/* Livedata board*/}
                {this.renderLiveData()}
                {/* Tabs and page content*/}
                {this.renderTabs()}
              </Grid>

              {/* SNACKBAR (for notifications)*/}
              <SnackbarView
                open={!!snackbarMessage}
                error={!!snackbarError}
                onClose={this.snackbarClose}
              >
                {snackbarMessage}
              </SnackbarView>

              {/* POPUP FOR SAMSUNG - warning when deal is saved with status = paused*/}
              <Dialog open={this.state.isSamsungPopupOpen} onClose={this.handleSamsungPopupClose}>
                <DialogTitle>Save deal with stopped status?</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Are you sure you want to save the deal with the "stopped" status? A deal with a
                    "stopped" status is
                    <b> not</b> editable, so this action is not reversible. The deal will also be
                    automatically set as
                    <b> inactive</b>.
                  </DialogContentText>
                  <DialogActions>
                    <Button onClick={this.handleSamsungPopupSave}>Yes, save the deal</Button>
                    <Button onClick={this.handleSamsungPopupClose}>No, cancel</Button>
                  </DialogActions>
                </DialogContent>
              </Dialog>
            </Panel>
          ) : (
            <Panel scroll>
              {/* PAGE CONTENT*/}
              {/* Nav Tabs*/}
              <Grid container direction='column'>
                {/* Livedata board*/}
                {this.renderLiveData()}
                {/* Tabs and page content*/}
                {this.renderTabs()}
              </Grid>

              {/* SNACKBAR (for notifications)*/}
              <SnackbarView
                open={!!snackbarMessage}
                error={!!snackbarError}
                onClose={this.snackbarClose}
              >
                {snackbarMessage}
              </SnackbarView>

              {/* POPUP FOR SAMSUNG - warning when deal is saved with status = paused*/}
              <Dialog open={this.state.isSamsungPopupOpen} onClose={this.handleSamsungPopupClose}>
                <DialogTitle>Save deal with stopped status?</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Are you sure you want to save the deal with the "stopped" status? A deal with a
                    "stopped" status is
                    <b> not</b> editable, so this action is not reversible. The deal will also be
                    automatically set as
                    <b> inactive</b>.
                  </DialogContentText>
                  <DialogActions>
                    <Button onClick={this.handleSamsungPopupSave}>Yes, save the deal</Button>
                    <Button onClick={this.handleSamsungPopupClose}>No, cancel</Button>
                  </DialogActions>
                </DialogContent>
              </Dialog>
            </Panel>
          )}
        </Panels>
      );
    }

    // Checks if the "Deal Type" field should be enabled for the current deal.
    private isDealTypeDisabled(deal: IDeal): boolean {
      // if the deal is connected to a third-party API, we only want the deal type to be enabled when the deal is created
      // (deal ID is 0)
      if (DEAL_SSP_WITH_API_LIST.includes(deal.BidderType)) {
        return deal.ID !== 0; // Disable if the deal is NOT being created.
      }

      // else, should not be disabled
      return false;
    }

    // Render the "Deal Type" dropdown.
    private renderDealTypeInput(
      deal: IDeal,
      // eslint-disable-next-line
      errors: { [p: string]: any },
    ): JSX.Element {
      return (
        <TextField
          fullWidth
          select
          label='Deal Type'
          name='DealType'
          value={deal.DealType}
          onChange={this.handleDealFormInputChange}
          error={get(errors, 'DealType', false)}
          disabled={this.isDealTypeDisabled(deal)}
          helperText={((): string | undefined => {
            if (get(errors, 'DealType', false)) {
              return `Deal Type ${get(errors, 'DealType', false)}`; // validation error
            }
            return undefined; // no helper text
          })()}
        >
          {/* function to render the deal type options for each SSP */}
          {(() => {
            // for SSP WITHOUT API
            if (DEAL_SSP_WITHOUT_API_LIST.includes(deal.BidderType)) {
              return [
                <MenuItem value={DealType.OpenAuction}>Open Auction</MenuItem>,
                <MenuItem value={DealType.PreferredDeal}>Preferred Deal</MenuItem>,
                <MenuItem value={DealType.PrivateAuction}>Private Auction</MenuItem>,
                <MenuItem value={DealType.ProgrammaticGuaranteed}>
                  Programmatic Guaranteed
                </MenuItem>,
              ];
            }
            // for Unruly
            if (deal.BidderType === 'rhythmone') {
              return [
                <MenuItem value={DealType.OpenAuction}>Open Auction</MenuItem>,
                <MenuItem value={DealType.PreferredDeal}>Preferred Deal</MenuItem>,
              ];
            }
            // for Samsung
            if (deal.BidderType === 'samsungssp') {
              return [
                <MenuItem value={DealType.ProgrammaticGuaranteed}>
                  Programmatic Guaranteed
                </MenuItem>,
              ];
            }
            // for IndexExchange
            if (deal.BidderType === 'indexExchange') {
              return [
                <MenuItem value={DealType.OpenAuction}>Open Auction</MenuItem>,
                <MenuItem value={DealType.PrivateAuction}>Private Auction</MenuItem>,
              ];
            }
            // default
            return <></>;
          })()}
        </TextField>
      );
    }

    // Render the "dealID" dropdown.
    private renderDealIDInput(
      deal: IDeal,
      errors: { [p: string]: any },
      didDealMakeBidRequest: boolean | undefined,
    ) {
      return (
        <TextField
          fullWidth
          required
          label='Deal ID'
          name='SspParams.dealID'
          onChange={this.handleDealFormInputChange}
          value={(deal.SspParams as IIndexExchangeToPublicaApiDeal).dealID}
          disabled={!!didDealMakeBidRequest} // If the deal makes any bid-request, the deal-id is not editable
          error={!!get(errors, 'SspParams.dealID', false)}
          helperText={((): string | undefined => {
            if (get(errors, 'SspParams.dealID', false)) {
              return `Deal ID ${get(errors, 'SspParams.dealID', false)}`; // validation error
            } else if (didDealMakeBidRequest) {
              return 'Deal made a bid-request, this cannot be changed';
            }
            return undefined; // no helper text
          })()}
        />
      );
    }

    // Render the "siteID" dropdown.
    private renderSiteIDInput = () => {
      const { siteIDsList } = this.state;
      return (
        <MaterialSearchDropdownMulti
          fontSize='16px'
          menuTitle='Site IDs'
          list={siteIDsList}
          enableMultiSelect={true}
          onChange={(list: IMenuList) => {
            this.setState({
              siteIDsList: list,
            });
          }}
          handleMenuAcceptClick={this.handleSiteIDsAcceptClick}
          disabled={
            (this.props.deal.SspParams as IIndexExchangeToPublicaApiDeal)
              .targetingInventoryGroupIDs &&
            (this.props.deal.SspParams as IIndexExchangeToPublicaApiDeal).targetingInventoryGroupIDs
              .length > 0
          }
        />
      );
    };

    // Render the "inventoryID" dropdown.
    private renderInventoryIDInput = () => {
      const { inventoryGroupIDsList } = this.state;
      return (
        <MaterialSearchDropdownMulti
          fontSize='16px'
          menuTitle='Inventory Group IDs'
          list={inventoryGroupIDsList}
          enableMultiSelect={true}
          onChange={(list: IMenuList) => {
            this.setState({
              inventoryGroupIDsList: list,
            });
          }}
          handleMenuAcceptClick={this.handleInventoryGroupIDsAcceptClick}
          disabled={
            (this.props.deal.SspParams as IIndexExchangeToPublicaApiDeal).targetingSiteIDs &&
            (this.props.deal.SspParams as IIndexExchangeToPublicaApiDeal).targetingSiteIDs.length >
              0
          }
        />
      );
    };

    // Render the "siteID" dropdown.
    private renderSeatIDInput = () => {
      const { seatIDsList } = this.state;
      return (
        <Grid style={{ paddingTop: 25 }}>
          <MaterialSearchDropdownMulti
            fontSize='16px'
            menuTitle='Buyer Seat ID'
            list={seatIDsList}
            enableMultiSelect={true}
            disableSortBy={true}
            onChange={(list: IMenuList) => {
              this.setState({
                seatIDsList: list,
              });
            }}
            handleMenuAcceptClick={this.handleSeatIDsAcceptClick}
            disabled={
              (this.props.deal.SspParams as IIndexExchangeToPublicaApiDeal).seatIDs &&
              (this.props.deal.SspParams as IIndexExchangeToPublicaApiDeal).seatIDs.length > 0
            }
          />
        </Grid>
      );
    };

    // Render the "Rate" (Bid Floor) field
    private renderRateInput(deal: IDeal) {
      return (
        <Grid item>
          <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
            style={{
              marginBottom: '12px',
            }}
          >
            {/* Rate title */}
            <Grid item style={{ fontSize: '16px', width: '170px' }}>
              Rate:
            </Grid>
            <Grid item>
              <NumberFormat
                label=''
                name='SspParams.rate'
                fullWidth
                value={(deal.SspParams as IIndexExchangeToPublicaApiDeal).rate}
                onChange={this.handleDealFormInputChange}
                customInput={TextField}
                thousandSeparator={true}
                error={!!get(this.state.errors, 'SspParams.rate', false)}
                helperText={((): string | undefined => {
                  if (get(this.state.errors, 'SspParams.rate', false)) {
                    return `Rate ${get(this.state.errors, 'SspParams.rate', false)}`; // validation error
                  }
                  return undefined; // no helper text
                })()}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    }

    // Render the "Priority" dropdown.
    private renderPriorityInput(deal: IDeal) {
      return (
        <TextField
          fullWidth
          select
          label='Priority'
          name='SspParams.priority'
          value={(deal.SspParams as IIndexExchangeToPublicaApiDeal).priority}
          onChange={this.handleDealFormInputChange}
          disabled={false}
          error={!!get(this.state.errors, 'SspParams.priority', false)}
          helperText={get(this.state.errors, 'SspParams.priority', false)}
        >
          {/* function to render the priority options for each SSP */}
          {(() => {
            // for IndexExchange
            if (deal.BidderType === 'indexExchange') {
              return [
                <MenuItem value={0}>0</MenuItem>,
                <MenuItem value={1}>1</MenuItem>,
                <MenuItem value={2}>2</MenuItem>,
                <MenuItem value={3}>3</MenuItem>,
                <MenuItem value={4}>4</MenuItem>,
                <MenuItem value={5}>5</MenuItem>,
                <MenuItem value={6}>6</MenuItem>,
                <MenuItem value={7}>7</MenuItem>,
                <MenuItem value={8}>8</MenuItem>,
                <MenuItem value={9}>9</MenuItem>,
                <MenuItem value={10}>10</MenuItem>,
              ];
            }
            // default
            return <></>;
          })()}
        </TextField>
      );
    }

    // Render the "Open Market" dropdown.
    private renderOpenMarketInput(deal: IDeal) {
      return (
        <TextField
          fullWidth
          select
          label='Open Market'
          name='SspParams.openMarket'
          value={(deal.SspParams as IIndexExchangeToPublicaApiDeal).openMarket}
          defaultValue={OpenMarket.PrivateDeal}
          onChange={this.handleDealFormInputChange}
          disabled={false}
          error={!!get(this.state.errors, 'SspParams.openMarket', false)}
          helperText={get(this.state.errors, 'SspParams.openMarket', false)}
        >
          {/* function to render the open market options for each SSP */}
          {(() => {
            // for IndexExchange
            if (deal.BidderType === 'indexExchange') {
              return [
                <MenuItem value={OpenMarket.PrivateDeal}>Private Deal</MenuItem>,
                <MenuItem value={OpenMarket.OpenDeal}>Open Deal</MenuItem>,
              ];
            }
            // default
            return <></>;
          })()}
        </TextField>
      );
    }

    // Render the "Payout" dropdown.
    private renderPayoutInput(deal: IDeal) {
      return (
        <TextField
          fullWidth
          select
          label='Payout'
          name='SspParams.payout'
          value={(deal.SspParams as IIndexExchangeToPublicaApiDeal).payout}
          defaultValue={1}
          onChange={this.handleDealFormInputChange}
          disabled={false}
          error={!!get(this.state.errors, 'SspParams.payout', false)}
          helperText={get(this.state.errors, 'SspParams.payout', false)}
        >
          {/* function to render the payout options for each SSP */}
          {(() => {
            // for IndexExchange
            if (deal.BidderType === 'indexExchange') {
              return [<MenuItem value={1}>True</MenuItem>, <MenuItem value={2}>False</MenuItem>];
            }
            // default
            return <></>;
          })()}
        </TextField>
      );
    }

    // Render the "DSP ID dropdown for IndexExchange"
    private renderIndexExchangeBuyerDspInput(
      deal: IDeal,
      dspID: number,
      errors: { [p: string]: any },
    ) {
      if (deal.BidderType === 'indexExchange') {
        return (
          <IndexExchangeDSPTargetingSelect
            label='Buyers DSP'
            name={'SspParams.dspID'}
            onChange={this.handleDealFormInputChange}
            value={dspID}
            error={!!get(errors, 'SspParams.dspID', false)}
            helperText={
              get(errors, 'SspParams.dspID', false)
                ? `Buyers DSP ${get(errors, 'SspParams.dspID', false)}`
                : ''
            }
          />
        );
      }
      // default
      return <></>;
    }

    // Render the "Human Verification" dropdown
    private renderHumanVerificationInput(deal: IDeal) {
      return (
        <Cols gap='4px'>
          <Col width={292}>
            <TextField
              fullWidth
              select
              label={'Human Verification'}
              name={'SspParams.humanVerification'}
              value={(deal.SspParams as IIndexExchangeToPublicaApiDeal).humanVerification}
              defaultValue={1}
              onChange={this.handleDealFormInputChange}
              disabled={false}
              error={!!get(this.state.errors, 'SspParams.humanVerification', false)}
              helperText={get(this.state.errors, 'SspParams.humanVerification', false)}
            >
              {/* function to render the deal type options for each SSP */}
              {(() => {
                // for IndexExchange
                if (deal.BidderType === 'indexExchange') {
                  return [
                    <MenuItem value={1}>True</MenuItem>,
                    <MenuItem value={2}>False</MenuItem>,
                  ];
                }
                // default
                return <></>;
              })()}
            </TextField>
          </Col>
          <Col paddingTop='20px'>
            <Tooltip
              // interactive
              title={`Specifies whether the buyer's creative campaigns should be evaluated against blocking criteria, where:
            \n true (default) = you want IX's Ad Quality team to review all new creatives before they compete in an auction against any brand, industry, DSP, or other blocks set in your campaign settings (Controls > Inventory > Campaign Settings).
            \n false = you want creatives that are bidding in this deal to only undergo an automated malicious threat scan.`}
              placeholder='right'
            >
              <InfoIcon style={{ width: '1rem', color: '#929599' }} />
            </Tooltip>
          </Col>
        </Cols>
      );
    }

    // Render the flight dates form for the deal.
    private renderFlightDates(deal: IDeal) {
      // get variables from the state
      const { errors, didDealMakeBidRequest } = this.state;
      // if the deal has served OR is Samsung and stopped, then the start/end date and imp goal cannot be edited
      const isEditDisabled =
        !!didDealMakeBidRequest ||
        (deal.BidderType === 'samsungssp' && (deal.SspParams as ISamsungDealParams).isDealStopped);
      // return the renderer
      return (
        <Grid item style={{ paddingBottom: '16px' }}>
          <Grid container direction='row' justify='flex-start' alignItems='center'>
            {/* Flight Dates title */}
            <Grid
              item
              style={{
                paddingTop: '16px',
                fontSize: '16px',
                width: '170px',
                transform: 'translateY(25%)',
              }}
            >
              Flight Dates:
            </Grid>
            {/* Flight Dates date pickers */}
            <Grid item style={{ paddingTop: '16px' }}>
              <DateTimeRangeComponent
                start={
                  deal.StartDate
                    ? moment(deal.StartDate).tz(this.props.session.publisher.Timezone)
                    : undefined
                }
                end={
                  deal.EndDate
                    ? moment(deal.EndDate).tz(this.props.session.publisher.Timezone)
                    : undefined
                }
                onChange={this.handleDateChange}
                enableSelectAll={true}
                timezone={this.props.session.publisher.Timezone}
                error={
                  Boolean(get(errors, 'StartDate', false)) || Boolean(get(errors, 'EndDate', false))
                }
                helperText={
                  Boolean(get(errors, 'StartDate', false)) || Boolean(get(errors, 'EndDate', false))
                    ? 'Please select a start/end date.'
                    : ''
                }
                disabledStart={isEditDisabled}
                disabledEnd={!deal.StartDate}
              />
            </Grid>
            {/* Flight Dates clear dates button */}
            <Grid item style={{ marginLeft: '10px', paddingTop: '16px' }}>
              <ModelSecondaryButton disabled={isEditDisabled}>
                <Typography
                  noWrap
                  style={{
                    textTransform: 'uppercase',
                    fontSize: 14,
                    fontWeight: 500,
                    marginLeft: 5,
                  }}
                  onClick={this.handleClearDates}
                >
                  Clear Dates
                </Typography>
              </ModelSecondaryButton>
            </Grid>
          </Grid>
        </Grid>
      );
    }

    // Render the flight dates form for the ssp params in deal.
    private renderSspParamsFlightDates(deal: IDeal) {
      // get variables from the state
      const { errors, didDealMakeBidRequest } = this.state;

      // if the deal has served, then the start/end date and imp goal cannot be edited
      const isEditDisabled = !!didDealMakeBidRequest;

      // return the renderer
      return (
        <Grid
          container
          direction='column'
          justifyContent='flex-start'
          alignItems='flex-start'
          style={{ paddingTop: '20px', paddingBottom: '10px' }}
          spacing={2}
        >
          {/* Flight Dates */}
          <Grid item>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center'>
              {/* Flight Dates title */}
              <Grid item style={{ fontSize: '16px', width: '170px' }}>
                Flight Dates:
              </Grid>
              {/* Flight Dates date pickers */}
              <Grid item>
                <DateTimeRangeComponent
                  start={
                    (deal.SspParams as IIndexExchangeToPublicaApiDeal).startDate
                      ? moment((deal.SspParams as IIndexExchangeToPublicaApiDeal).startDate).tz(
                          this.props.session.publisher.Timezone,
                        )
                      : undefined
                  }
                  end={
                    (deal.SspParams as IIndexExchangeToPublicaApiDeal).endDate
                      ? moment((deal.SspParams as IIndexExchangeToPublicaApiDeal).endDate).tz(
                          this.props.session.publisher.Timezone,
                        )
                      : undefined
                  }
                  onChange={this.handleDateChange}
                  enableSelectAll={true}
                  timezone={this.props.session.publisher.Timezone}
                  error={
                    get(errors, 'SspParams.startDate', false) ||
                    get(errors, 'SspParams.endDate', false)
                  }
                  helperText={
                    get(errors, 'SspParams.startDate', false) ||
                    get(errors, 'SspParams.endDate', false)
                      ? 'Please select a start/end date.'
                      : ''
                  }
                  disabled={isEditDisabled}
                />
              </Grid>
              {/* Flight Dates clear dates button */}
              <Grid item style={{ marginLeft: '10px' }}>
                <ModelSecondaryButton disabled={isEditDisabled}>
                  <Typography
                    noWrap
                    style={{
                      textTransform: 'uppercase',
                      fontSize: 14,
                      fontWeight: 500,
                      marginLeft: 5,
                    }}
                    onClick={this.handleClearDates}
                  >
                    Clear Dates
                  </Typography>
                </ModelSecondaryButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }

    private renderImpressionGoal(deal: IDeal) {
      // get variables from the state
      const { errors } = this.state;

      // if the deal has served OR is Samsung and stopped, then the start/end date and imp goal cannot be edited
      const isEditDisabled =
        deal.BidderType === 'samsungssp' && (deal.SspParams as ISamsungDealParams).isDealStopped;

      {
        /* Impression Goal */
      }

      return (
        <Cols style={{ alignItems: 'flex-start', paddingBottom: '16px' }}>
          <Col style={{ width: '170px', minWidth: '170px', transform: 'translateY(25%)' }}>
            <Text>Impression Goal:</Text>
          </Col>
          <Col>
            <NumberFormat
              label=''
              name='ImpressionGoal'
              fullWidth
              value={deal.ImpressionGoal}
              onChange={this.handleDealChange}
              customInput={TextField}
              thousandSeparator={true}
              disabled={!deal.StartDate || !deal.EndDate || isEditDisabled}
              error={!!get(errors, 'ImpressionGoal', false)}
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              helperText={get(errors, 'ImpressionGoal', false)}
            />
            <Cols
              marginTop={spacing.base}
              style={{ alignItems: 'center', transform: 'translateX(-8px)' }}
            >
              <Col>
                <Switch
                  name='EnableOverDelivery'
                  checked={EBool.isTrue(deal.EnableOverDelivery)}
                  onChange={() => {
                    if (this.props.onChange) {
                      this.props.onChange({
                        ...this.props.deal,
                        EnableOverDelivery: EBool.isTrue(deal.EnableOverDelivery)
                          ? EBool.EBool_FALSE
                          : EBool.EBool_TRUE,
                      });
                    }
                  }}
                />
              </Col>
              <Col>
                <Text tKey='EnsureSlightOverDelivery' />
              </Col>
              <Col displayFlex paddingLeft={spacing.extraSmall}>
                <TooltipWithTranslation
                  tKey='EnsureSlightOverDeliveryTooltip'
                  tProps={{ item: ct('Deal') }}
                >
                  <div>
                    <IconV2 small name='info' color={publicaColors.mediumGray} />
                  </div>
                </TooltipWithTranslation>
              </Col>
            </Cols>
          </Col>
        </Cols>
      );
    }

    private renderBidFloor(deal: IDeal) {
      return (
        <Grid item style={{ paddingBottom: '16px' }}>
          <Grid
            container
            direction='row'
            justify='flex-start'
            alignItems={
              !EBool.isTrue(this.props.session.publisher.EnableOtherCurrency) ||
              deal.CurrencyDisplayed === ECurrencyType.CURRENCY_TYPE_USD ||
              isNil(deal.CurrencyDisplayed)
                ? 'flex-end'
                : 'center'
            }
          >
            <Grid item style={{ fontSize: '16px', width: '170px' }}>
              Bid Floor:
            </Grid>
            {EBool.isTrue(this.props.session.publisher.EnableOtherCurrency) ? (
              <Grid item style={{ marginTop: '10px' }}>
                <CurrencyConverter
                  className='pb-bidder-settings-form-view_textfield-bid-floor'
                  currencies={CurrencyDisplayedItem}
                  currency={convertECurrencyTypeToString(deal.CurrencyDisplayed) || CurrencyTypeUSD}
                  isErrored={!!get(this.state.errors, 'BidFloor', false)}
                  onChange={({ uiPrice, uiCurrency }) =>
                    this.handleChangeBidFloorAndBidFloorCurrency(uiPrice, uiCurrency)
                  }
                  price={String(deal.BidFloor)}
                  displayCurrencyLabel={false}
                />
              </Grid>
            ) : (
              <Grid item>
                <NumberFormat
                  label=''
                  name='BidFloor'
                  fullWidth
                  value={deal.BidFloor}
                  onChange={this.handleDealChange}
                  customInput={TextField}
                  thousandSeparator={true}
                  error={!!get(this.state.errors, 'BidFloor', false)}
                  helperText={get(this.state.errors, 'BidFloor', false)}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      );
    }

    // Render all the special fields related to the Samsung SSP partner.
    private renderSamsungParams(deal: IDeal) {
      // get the possible deal statuses
      const possibleDealStatuses = this.genSamsungStatusList();

      // if the Samsung deal is stopped, then it's not editable
      const isDealEditable = !(deal.SspParams as ISamsungDealParams).isDealStopped;

      return (
        <ModelPrimaryContainer container justify='space-between'>
          <Grid container direction='column' justify='center' alignItems='center'>
            {/* Row 1 */}
            <Grid item style={{ width: 'inherit' }}>
              <Grid
                container
                justify='space-between'
                alignItems='center'
                style={{ paddingBottom: 18 }}
                spacing={2}
              >
                {/* eCPM */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required
                    label='eCPM'
                    type='string'
                    name='SspParams.ecpm'
                    value={(deal.SspParams as ISamsungDealParams).ecpm}
                    onChange={this.handleDealFormInputChange}
                    error={!!get(this.state.errors, 'SspParams.ecpm', false)}
                    helperText={
                      get(this.state.errors, 'SspParams.ecpm', false)
                        ? `eCPM ${get(this.state.errors, 'SspParams.ecpm', false)}`
                        : ''
                    }
                    disabled={!isDealEditable}
                  />
                </Grid>

                {/* DSP Partner */}
                <Grid item xs={6}>
                  <TextField
                    name='SspParams.partnerName'
                    select
                    fullWidth
                    required
                    onChange={this.handleDealFormInputChange}
                    value={(deal.SspParams as ISamsungDealParams).partnerName}
                    error={!!get(this.state.errors, 'SspParams.partnerName', false)}
                    helperText={
                      get(this.state.errors, 'SspParams.partnerName', false)
                        ? `DSP Partner ${get(this.state.errors, 'SspParams.partnerName', false)}`
                        : ''
                    }
                    label={'DSP Partner'}
                    disabled={!isDealEditable}
                  >
                    <MenuItem value='trader'>Trader</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </Grid>

            {/* Row 2 */}
            <Grid item style={{ width: 'inherit' }}>
              <Grid
                container
                justify='space-between'
                alignItems='center'
                style={{ paddingBottom: 18 }}
                spacing={2}
              >
                {/* Status */}
                <Grid item xs={6}>
                  <TextField
                    name='SspParams.status'
                    select
                    fullWidth
                    required
                    onChange={this.handleDealFormInputChange}
                    value={(deal.SspParams as ISamsungDealParams).status}
                    error={!!get(this.state.errors, 'SspParams.status', false)}
                    helperText={
                      get(this.state.errors, 'SspParams.status', false)
                        ? `Status ${get(this.state.errors, 'SspParams.status', false)}`
                        : ''
                    }
                    label={'Status'}
                    disabled={!isDealEditable}
                  >
                    {/* list of the possible status for the Samsung deal */}
                    <MenuItem value='PAUSED' disabled={!possibleDealStatuses.includes('PAUSED')}>
                      Paused
                    </MenuItem>
                    <MenuItem value='STOPPED' disabled={!possibleDealStatuses.includes('STOPPED')}>
                      Stopped
                    </MenuItem>
                    <MenuItem value='PENDING' disabled={!possibleDealStatuses.includes('PENDING')}>
                      Pending
                    </MenuItem>
                    <MenuItem value='RUNNING' disabled={!possibleDealStatuses.includes('RUNNING')}>
                      Running
                    </MenuItem>
                  </TextField>
                </Grid>

                {/* Budget */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    required
                    label='Budget'
                    type='string'
                    name='SspParams.totalAdvBudget'
                    value={(deal.SspParams as ISamsungDealParams).totalAdvBudget}
                    onChange={this.handleDealFormInputChange}
                    error={!!get(this.state.errors, 'SspParams.totalAdvBudget', false)}
                    helperText={
                      get(this.state.errors, 'SspParams.totalAdvBudget', false)
                        ? `Budget ${get(this.state.errors, 'SspParams.totalAdvBudget', false)}`
                        : ''
                    }
                    disabled={!isDealEditable}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ModelPrimaryContainer>
      );
    }
  },
);
